import type { SxProps, Theme } from '@mui/material';

export type AppProviderStyles = {
  redirectingContainer: SxProps<Theme>;
  authErrorContainer: SxProps<Theme>;
  renderingErrorContainer: SxProps<Theme>;
  renderingErrorPre: SxProps<Theme>;
  renderingErrorButton: SxProps<Theme>;
};

export const appProviderStyles: AppProviderStyles = {
  redirectingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
  authErrorContainer: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    padding: '15px',
    backgroundColor: '#ffeeee',
    border: '1px solid #ffcccc',
    borderRadius: '4px',
    maxWidth: '500px',
  },
  renderingErrorContainer: {
    padding: '20px',
    backgroundColor: '#fff0f0',
    color: '#d32f2f',
    fontFamily: 'Arial, sans-serif',
  },
  renderingErrorPre: {
    backgroundColor: '#f8f8f8',
    padding: '10px',
    overflow: 'auto',
  },
  renderingErrorButton: {
    padding: '8px 16px',
    backgroundColor: '#d32f2f',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '15px',
  },
};
